import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// core version + navigation, pagination modules:
import {Swiper, Navigation, Pagination, Grid, Autoplay, Thumbs} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/grid';
import 'swiper/css/autoplay';
window.Swiper = Swiper

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// Lazyload
import lazySizes from 'lazysizes';

// fslightbox
import FsLightbox from "fslightbox";

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// PureCounter
import PureCounter from "@srexi/purecounterjs";

// Plyr
import Plyr from 'plyr';
import 'plyr/src/sass/plyr.scss'

// Typed.JS
import Typed from 'typed.js';

let typedInstance;

const setupApp = ()=>
{
    lazySizes.init();
    refreshFsLightbox();

    // Fancybox
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    // Hero counter
    const pure = new PureCounter({
        formater: 'fa-IR'
    });

    // Introduce section video
    if( document.getElementById("myVideoPlayer1") ) {
        const myVideoPlayer1 = new Plyr('#myVideoPlayer1', {
            ratio: '16:9',
        });
    }

    if( !typedInstance && document.getElementById("heroText") ) {
        typedInstance = new Typed('#heroText', {
            strings: [
                "خلاقیت بی مرز، داستانهای تصویری فراموش نشدنی",
                "ما تصویر می‌سازیم تا روایت‌هایت ماندگار شوند",
                "از یک ایده ساده تا یک برند فراموش‌نشدنی"
            ],
            typeSpeed: 50,
            backSpeed: 30,
            backDelay: 2000,
            startDelay: 500,
            loop: true,
            smartBackspace: true,
            fadeOut: true,
            fadeOutDelay: 300,
        });
    }

    let brandSwiper = new Swiper("#brandSwiper", {
        modules: [Autoplay],
        slidesPerView: 3,
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: 10,
        loop: true,
        autoplay: {
            delay: 3,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        speed: 1500,
        breakpoints: {
            480: {
                slidesPerView: 2.5,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                slidesPerView: 5,
            },
        },
    });

    let portfolioCatSwiper = new Swiper("#portfolioCatSwiper", {
        modules: [Grid],
        grid: {
            rows: 2,
            fill: 'row',
        },
        slidesPerView: 1.6,
        loop: true,
        spaceBetween: 0,
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 3.2,
            },
            1280: {
                slidesPerView: 4,
                enabled: false,
                loop: false,
            },
        },
    });

    let portfolioSwiper = new Swiper("#portfolioSwiper", {
        loop: true, // ادامه پیدا کردن اسلایدها
        centeredSlides: true, // اسلاید فعال در وسط قرار گیرد
        centeredSlidesBounds: true, // محدود کردن اسلایدهای اطراف
        slidesPerView: 2, // تعداد اسلایدهای نمایش داده شده در یک زمان
        spaceBetween: 20, // فاصله ثابت بین اسلایدها
        breakpoints: {
            480: {
                slidesPerView: 2.8, // تعداد اسلایدها در صفحه‌های کوچک‌تر
                spaceBetween: 10, // فاصله کمتر در صفحه‌های کوچک‌تر
            },
            768: {
                slidesPerView: 3.5,
                spaceBetween: 15,
            },
            1024: {
                slidesPerView: 3.5,
                spaceBetween: 20,
            },
            1280: {
                slidesPerView: 5,
                spaceBetween: 30,
            },
        },
    });

    let shopSwiper = new Swiper("#shopSwiper", {
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 20,
        breakpoints: {
            480: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 3.8,
            },
            1024: {
                slidesPerView: 4.5,
            },
            1280: {
                slidesPerView: 5,
                centeredSlidesBounds: false,
                centeredSlides: false,
            },
        },
    });

    let blogSwiper = new Swiper("#blogSwiper", {
        modules: [Navigation],
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 3.5,
            },
            1280: {
                slidesPerView: 4,
            },
        },
        navigation: {
            nextEl: "#blogSwiperNext",
            prevEl: "#blogSwiperPrev",
        },
    });

    const portfolioGalleryThumb = new Swiper('.portfolio-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 5.5,
        centeredSlides:true,
        centeredSlidesBounds:true,
        freeMode: true,
        loop: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
            320: {
                slidesPerView: 3.5,
            },
            480: {
                slidesPerView: 3.5,
            },
            640: {
                slidesPerView: 4.5,
            },
            1280:{
                slidesPerView: 5.5,
            },
        }
        // thumbs: {
        //   swiper: productGalleryThumb
        // }
    });

    const portfolioGallery = new Swiper('.portfolio-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // clickable:"true",
        spaceBetween: 10,

        thumbs: {
            swiper : portfolioGalleryThumb
        },
    });

    // ABOUT SECTION
    window.addEventListener('scroll', () => {
        const lamp = document.querySelector('#lamp');
        const picture = document.querySelector('#picture');

        if( lamp && picture )
        {
            const lampRect = lamp.getBoundingClientRect();
            const lampTop = lampRect.top;
            const lampBottom = lampRect.bottom;
            const lampHeight = lampRect.height;
            const windowHeight = window.innerHeight;

            if (lampTop + 250 <= windowHeight && lampTop + lampHeight > 250 && lampBottom >= 350) {
                lamp.classList.add('onLamp');
                lamp.classList.remove('offLamp');
                picture.classList.add('onOpacity');
                picture.classList.remove('offOpacity');
            } else {
                lamp.classList.remove('onLamp');
                lamp.classList.add('offLamp');
                picture.classList.remove('onOpacity');
                picture.classList.add('offOpacity');
            }
        }
    });
};

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})

